// AdminSerffPlansLoadStatus
const SET_PLAN_LOAD_STATUS_DATA = 'SET_PLAN_LOAD_STATUS_DATA';
const SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS';
const SET_FILTERS = 'SET_FILTERS';

export const ADMIN_SERFF_PLAN_LOAD_STATUS_ACTION_TYPES = {
    SET_PLAN_LOAD_STATUS_DATA,
    SET_FILTER_OPTIONS,
    SET_FILTERS
};

// AdminSerffTransferStatus
const SET_TRANSFER_STATUS_DATA = 'SET_TRANSFER_STATUS_DATA';
const SET_FILTER_TRANSFER_OPTIONS = 'SET_FILTER_TRANSFER_OPTIONS';
const FETCH_FILTER_TRANSFER_OPTIONS = 'FETCH_FILTER_TRANSFER_OPTIONS';
const SET_TRANSFER_FILTERS = 'SET_TRANSFER_FILTERS';
const SET_TRANSFER_ATTACHMENTS_LIST = 'SET_TRANSFER_ATTACHMENTS_LIST';

export const ADMIN_SERFF_TRANSFER_STATUS_ACTION_TYPES = {
    SET_TRANSFER_STATUS_DATA,
    SET_FILTER_TRANSFER_OPTIONS,
    FETCH_FILTER_TRANSFER_OPTIONS,
    SET_TRANSFER_FILTERS,
    SET_TRANSFER_ATTACHMENTS_LIST
};
